import 'alpinejs';
import lozad from 'lozad'

require('./modules/gallery-slider');
require('./modules/matches-slider');
require('./modules/youtube-iframe-fixer');
require('./modules/table-overflow-fixer');
require('fslightbox');

/* lozad */
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
